import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Container, Row, Col, Alert, Button } from 'react-bootstrap'
import { LoadingSpinner, WizardSteps } from '../../components'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { certificates as endpoints } from '@URLS'
import { linkPaths, OBJECT_ID } from '../urls'
import { ReviewContentLayout } from './ReviewContentLayout'
import FinishedCertImage from './FinishedCertImage'
import { CertHeader } from './CertHeader'
import { CertPreamble } from './CertPreamble'
import { CertReason } from './CertReason'
import { CertAward } from './CertAward'

export const Review = () => {
  const [state, dispatch] = useStateValue()
  const history = useHistory()
  const [isFinishing, setIsFinishing] = useState(false)

  useEffect(() => {
    return () => {
      dispatch({ type: 'SET_ERRORS', payload: [] })
    }
  }, [])

  const goBack = e => {
    e.preventDefault()
    history.push(linkPaths.requirements)
  }

  const finish = async e => {
    e.preventDefault()
    setIsFinishing(true)
    const certData = {
      ...state.certInfo,
      chapters: state.certInfo.selectedChapters,
      assessments: state.certInfo.selectedAssessments,
      passingScore: state.certInfo.passingScore,
    }
    try {
      if (state.certInfo.retrievedEditData) {
        await client.put(endpoints.update({ id: OBJECT_ID }), { certInfo: certData })
      } else {
        await client.post(endpoints.create(), { certInfo: certData })
      }
      dispatch({ type: 'FINISH_CERTIFICATE' })
    } catch (err) {
      console.error('Error saving certificate', err)
      const msg =
        err.message === 'Network Error'
          ? err.message + ', seal image file may be too large'
          : err.message
      dispatch({ type: 'SET_ERRORS', payload: [msg] })
      setIsFinishing(false)
    }
  }

  return (
    <div>
      <WizardSteps
        edit={state.certInfo.retrievedEditData}
        step={3}
        linkPaths={linkPaths}
        heading="Certificate"
        subHeading="Review"
      />
      <div className="review_container">
        {state.errors.length > 0 && (
          <Container>
            <Row>
              <Col xs={24} sm={12} smOffset={6}>
                <Alert variant="danger">
                  <ul>
                    {state.errors.map((msg, i) => (
                      <li key={i}>{msg}</li>
                    ))}
                  </ul>
                </Alert>
              </Col>
            </Row>
          </Container>
        )}
        <div className="flex_container">
          <div id="certificate_box">
            <div id="outer_certificate">
              <div id="inner_certificate">
                <CertHeader disable />
                <CertPreamble disable />
                <div className="text-center" id="user_name">
                  Taylor Smith
                </div>
                <CertReason disable />
                <CertAward disable />
                <div className="image_and_date">
                  <div className="image_date" id="image">
                    <FinishedCertImage
                      imageLoaded={state.certInfo.imageLoaded}
                      image={state.certInfo.image}
                      imageName={state.certInfo.imageName}
                    />
                  </div>
                  <div className="image_date" id="date">
                    (Date Awarded)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ReviewContentLayout />
        </div>
        <div className="btn_container">
          <Button variant="primary" onClick={goBack}>
            Back
          </Button>
          <Button
            variant="primary"
            disabled={state.errors.length > 0 || isFinishing}
            onClick={finish}
          >
            <span>Finish</span>{' '}
            {isFinishing && state.errors.length === 0 ? (
              <LoadingSpinner
                style={{ fontSize: '1em', color: 'white' }}
                outerClass={'inline'}
              />
            ) : (
              ''
            )}
          </Button>
        </div>
      </div>
    </div>
  )
}
